import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { ModalComponent } from "../modal.component";

@Component({
    template: `
        @if (isInit) {
            <div class="s25-ng">
                <s25-modal-header [data]="data"></s25-modal-header>
                <div class="modal-body">
                    <s25-ng-masquerade-switch-roles
                        [isModal]="false"
                        (masquerade)="onMasquerade($event)"
                        (cancelled)="onCancelled()"
                    ></s25-ng-masquerade-switch-roles>
                </div>
            </div>
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ModalSwitchRoleComponent
    extends ModalComponent<{
        items: any;
        reference?: string;
        onSave?: () => unknown;
        onCancel?: () => unknown;
    }>
    implements OnInit
{
    isInit = false;

    ngOnInit() {
        this.isInit = true;
    }

    onSaved() {
        this.data.onSave?.();
        this.data.closeModal();
    }

    onCancelled() {
        this.data.closeModal();
    }
}
